/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{isString as t,singleColorRegex as a,floatRegex as o}from"../utils.js";const r=(o,r)=>e=>Boolean(t(e)&&a.test(e)&&e.startsWith(o)||r&&Object.prototype.hasOwnProperty.call(e,r)),e=(a,r,e)=>s=>{if(!t(s))return s;const[p,l,n,c]=s.match(o);return{[a]:parseFloat(p),[r]:parseFloat(l),[e]:parseFloat(n),alpha:void 0!==c?parseFloat(c):1}};export{r as isColorString,e as splitColor};
//# sourceMappingURL=utils.js.map
